class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.productId = this.dataset.productId;
    if(!this.input) {
      throw new Error('Quantity input element requires a form input field.');
    }
    this.changeEvent = new Event('change', {bubbles: true});

    const increaseTrigger = this.querySelector('[data-quantity-increase]');
    if(increaseTrigger) {
      increaseTrigger.addEventListener('click', this.handleIncrease.bind(this))
    }
    const decreaseTrigger = this.querySelector('[data-quantity-decrease]');
    if(decreaseTrigger) {
      decreaseTrigger.addEventListener('click', this.handleDecrease.bind(this))
    }
  }

  handleIncrease(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    this.increase();
    this.updateProductForm();
    if(previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  handleDecrease(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    this.decrease();
    this.updateProductForm();
    if(previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  increase() {
    this.input.stepUp();
  }

  decrease() {
    this.input.stepDown();
  }

  updateProductForm() {
    if(!this.productId) {
      return;
    }
    document.querySelectorAll(`product-form[data-product-id="${this.productId}"]`)
      .forEach(i => {
        const quantityInput = i.querySelector('input[name="quantity"]');
        if(quantityInput) {
          quantityInput.value = this.input.value;
        }
      })
  }
}

customElements.define('quantity-input', QuantityInput);

class CartRemove extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    })
  }
}

customElements.define('cart-remove', CartRemove);

class CartNote extends HTMLElement {
  connectedCallback() {
    this.querySelector('textarea').addEventListener('change', debounce((event) => {
      fetch(`${routes.cart_update_url}`, { 
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ note: event.target.value }) 
      });
    }, 150))
  }
}

customElements.define('cart-note', CartNote);

class CartItems extends HTMLElement {
  connectedCallback() {
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'MainCart',
        section: this.dataset.id,
        selector: 'cart-items'
      },
      {
        id: 'MainCart',
        section: this.dataset.id,
        selector: '#MainCart-blocks',
      },
      {
        id: 'cart-icon-bubble',
        section: 'header',
        selector: '#cart-icon-bubble'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    fetch(`${routes.cart_change_url}`, { 
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        line: parseInt(line),
        quantity: quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      })
    })
    .then(response => response.json())
    .then(response => {
      if(response.status) {
        this.disableLoading();
        const errors = document.getElementById('MainCart-CartErrors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = response.message;
      }
      else {
        this.renderContents(response);
        this.disableLoading();
      }
    })
    .catch(error => {
      this.disableLoading();
      const errors = document.getElementById('MainCart-CartErrors') || document.getElementById('CartDrawer-CartErrors');
      errors.textContent = 'Something went wrong.';
    })
  }

  renderContents(parsedState) {
    if(parsedState.item_count === 0) {
      this.setAttribute('data-cart-empty', false);
    }
    else {
      this.removeAttribute('data-cart-empty');
    }
    this.getSectionsToRender().forEach(section => {
      const sectionElement = document.getElementById(section.id);
      if(sectionElement) {
        const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;
        if(parsedState?.sections && parsedState?.sections[section.section] !== null) {
          elementToReplace.innerHTML = getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        }
      }
    })
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('MainCart-Items') || document.getElementById('CartDrawer-Items');
    mainCartItems.setAttribute('data-state', 'loading');

    const cartItemElement = this.querySelector(`#CartItem-${line}`) || this.querySelector(`#CartDrawer-Item-${line}`);
    if(cartItemElement) {
      cartItemElement.setAttribute('data-state', 'loading');
    }

    document.activeElement.blur();
  }

  disableLoading() {
    const mainCartItems = document.getElementById('MainCart-Items') || document.getElementById('CartDrawer-Items');
    mainCartItems?.setAttribute('data-state', 'waiting');

    const cartItemElements = this.querySelectorAll('tr[data-state=loading]');
    cartItemElements.forEach(i => i.setAttribute('data-state', 'waiting'))
  }
}

customElements.define('cart-items', CartItems);

class CartDrawerItems extends CartItems {

  get drawer() {
    return this.closest('page-drawer');
  }

  getSectionsToRender() {
    const sectionId = this.drawer.dataset.shopifyId.split('shopify-section-');
    return [
      {
        id: 'cart-drawer-aside',
        section: sectionId[sectionId.length - 1],
        selector: 'cart-drawer-items',
      },
      {
        id: 'cart-drawer-aside',
        section: sectionId[sectionId.length - 1],
        selector: '#CartDrawer-blocks',
      },
      {
        id: 'cart-icon-bubble',
        section: 'header',
        selector: '#cart-icon-bubble'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);